import { NextPage } from "next";
import { Grid, GridItem, useColorModeValue, Box } from "@chakra-ui/react";

// common components
import { Subtitle, StakingSection, HeadPage } from "ui";

// components
import ExchangeInfo from "components/ExchangeInfo";
import DefiPreview from "components/DefiPreview";
import Disclaimer from "components/Disclaimer";

// utils
import { auditData } from "utils/auditData";
import stakingTabsData from "utils/stakingTabsData";

//images
import lightLogo from "assets/hederaLight.svg";
import darkLogo from "assets/hederaDark.svg";

const Home: NextPage = () => {
  const logo = useColorModeValue(lightLogo, darkLogo);

  return (
    <>
      <HeadPage
        title="Hedera Staking - Liquid Staking With Hbar Simplified|Stader Labs"
        keywords="hedera staking, hedera crypto, hbarcrypto"
        url="https://www.staderlabs.com/hedera/"
        description="Hedera Staking - Stake Hbar/hedera Crypto With Stader & earn rewards while Keeping Full Control of Your Staked Tokens. Start staking with Stader labs."
      />
      <Subtitle
        title="HBAR"
        description="Stake HBAR and use HBARX across DeFi protocols while earning rewards"
        logo={logo}
        tag={"Audited"}
        tagTooltip="Click to know more on audits"
        auditData={auditData}
      />
      <ExchangeInfo />
      <Grid templateColumns="repeat(12, 1fr)" gap={6} mt={6}>
        <GridItem colSpan={{ sm: 12, md: 12, lg: 7 }}>
          <StakingSection tabdata={stakingTabsData} />
          <Box mt="1rem">
            <Disclaimer />
          </Box>
        </GridItem>
        <GridItem colSpan={{ sm: 12, md: 12, lg: 5 }}>
          <DefiPreview />
        </GridItem>
      </Grid>
    </>
  );
};

export default Home;
